/*
//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     Lifetime 
//   Details:    Lifetime store
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 103782 10/12/19 JC  M01  Expanded for training
// 104759 11/12/19 JC  M02  Navigator now soft coded, based on system control configuration
//-------------------------------------------------------
*/
import { systemControlActions } from './SystemControl';
import { itemActions } from './Items';
import { itemCategories } from '../constants/ItemCategories';
import { itemTypeActions } from './ItemTypes';
import { detailsActions } from './MyDetails';
import { planActions } from './MyPlan';

export const lifetimeActions = {
    onLogIn,
    onLogInExtended,
	onLogOut
};

function onLogIn() {
	// These actions get run when the user successfully logs in as 
	// they require a valid authentication token
	return (dispatch) => {
		dispatch(systemControlActions.get());

        //M02 moved to onLogInExtended
		//dispatch(itemActions.getPage(1, itemCategories.unreadNotices, -1));
		//dispatch(itemActions.getPage(1, itemCategories.unreadDocuments, -1));
        //dispatch(itemActions.getPage(1, itemCategories.unreadPay, -1));
        //dispatch(itemActions.getPage(1, itemCategories.uncompletedTraining, -1)); //M01

		// unread categories will be loaded by the pages above
		// so we only pre-load the read categoris here

		dispatch(itemTypeActions.get(itemCategories.readNotices));
		dispatch(itemTypeActions.get(itemCategories.readDocuments));
        dispatch(itemTypeActions.get(itemCategories.readPay));
        dispatch(itemTypeActions.get(itemCategories.completedTraining)); //M01

		dispatch(detailsActions.get());
		dispatch(planActions.get());

	};
}

//M02
function onLogInExtended(configuration) {
    // These actions get run when the user successfully logs in as 
    // they require a valid authentication token
    // BUT AFTER WE'VE GOT SYSTEM CONTROL
    return (dispatch) => {

        //check system control for each option
        if (configuration.epNoticesEnabled === true) {
            dispatch(itemActions.getPage(1, itemCategories.unreadNotices, -1));
        } else {
            dispatch(itemTypeActions.get(itemCategories.unreadNotices));
        }

        if (configuration.epDocumentsEnabled === true) {
            dispatch(itemActions.getPage(1, itemCategories.unreadDocuments, -1));
        } else {
            dispatch(itemTypeActions.get(itemCategories.unreadDocuments));
        }

        if (configuration.epMyPayEnabled === true) {
            dispatch(itemActions.getPage(1, itemCategories.unreadPay, -1));
        } else {
            dispatch(itemTypeActions.get(itemCategories.unreadPay));
        }

        if (configuration.epMyTrainingEnabled === true) {
            dispatch(itemActions.getPage(1, itemCategories.uncompletedTraining, -1));
        } else {
            dispatch(itemTypeActions.get(itemCategories.uncompletedTraining));
        }        
    };
}

function onLogOut() {
	localStorage.removeItem('user');
	localStorage.removeItem('systemControl');
}